import { createContext, useContext } from 'react';

/** Opens a rulebook image full screen: `openImage(src, alt)`. The Rules screen provides it. */
export const ImageViewerContext = createContext(() => {});

export const useOpenImage = () => useContext(ImageViewerContext);
